export default "__VITE_ASSET__6f4a9d1a__"